export class Base64EncoderService {
  encode(data: string): string {
    return btoa(data);
  }
}
